import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import arrow from "../../../../src/assets/images/arrow-right.svg";
import ARealiserImg from "../../../../src/assets/images/ARealiser.svg";
import EnCoursImg from "../../../../src/assets/images/EnCours.svg";
import PretImg from "../../../../src/assets/images/Pret.svg";
import TermineImg from "../../../../src/assets/images/Termine.svg";
import EchuImg from "../../../../src/assets/images/Echu.svg";
import AnnuleImg from "../../../../src/assets/images/Annule.svg";
import { ChangetabFilterList } from "../../../redux/actions/design";
import { useDispatch } from "react-redux";
import "./FilterModal.css";

function FilterModal({ show, handleClose, setFilterActiv }) {
  const dispatch = useDispatch();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);

  const options = [
    { img: ARealiserImg, label: "À réaliser", value: "ARealiser" },
    { img: EnCoursImg, label: "À finaliser", value: "EnCours" },
    { img: PretImg, label: "À calibrer", value: "Pret" },
    { img: TermineImg, label: "Terminé", value: "Termine" },
    { img: EchuImg, label: "Échu", value: "Echu" },
    { img: AnnuleImg, label: "Annulé", value: "Annule" },
  ];

  useEffect(() => {
    const savedOptions = sessionStorage.getItem("selectedFilterOptions");
    const savedfilterActiv = sessionStorage.getItem("filterActiv");
    if (savedOptions) {
      setSelectedOptions(JSON.parse(savedOptions));
    }
    if (savedfilterActiv) {
      setFilterActiv(JSON.parse(savedfilterActiv));
    }
  }, []);

  const handleCheckboxChange = (option) => {
    setSelectedOptions((prev) =>
      prev.includes(option.value)
        ? prev.filter((item) => item !== option.value)
        : [...prev, option.value]
    );
  };

  const handleConfirm = () => {
    dispatch(ChangetabFilterList(selectedOptions));
    setFilterActiv(true);

    if (selectedOptions.length <= 0) {
      setFilterActiv(false);
      sessionStorage.removeItem("selectedFilterOptions");
      sessionStorage.removeItem("filterActiv");
    } else {
      sessionStorage.setItem(
        "selectedFilterOptions",
        JSON.stringify(selectedOptions)
      );
      sessionStorage.setItem("filterActiv", JSON.stringify(true));
    }
    handleClose();
  };

  const handleCloseModal = () => {
    handleClose();
  };

  const toggleOptions = () => {
    setShowOptions((prev) => !prev);
  };

  return (
    <Dropdown.Menu show={show} className="parent" style={{ minWidth: "250px" }}>
      <div className="d-flex justify-content-between align-items-center mb-2 px-3">
        <span
          className="fw-bold text-dark"
          style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#534953" }}
        >
          Status calibrage
        </span>
        <button
          onClick={toggleOptions}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            cursor: "pointer",
          }}
        >
          <img src={arrow} alt="Toggle options" />
        </button>
      </div>
      {showOptions && (
        <Form className="mb-4">
          {options.map((option) => (
            <div
              key={option.value}
              className="d-flex justify-content-between mb-2 px-3"
            >
              <div>
                <img src={option.img} alt="" className="mr-2" />
                <span style={{ fontWeight: "500", color: "#534953" }}>
                  {option.label}
                </span>
              </div>
              <Form.Check
                type="checkbox"
                checked={selectedOptions.includes(option.value)}
                onChange={() => handleCheckboxChange(option)}
              />
            </div>
          ))}
        </Form>
      )}

      <hr
        style={{
          margin: "10px 0",
          borderColor: "gray",
          borderWidth: "1px",
          opacity: 0.3,
          width: "75%",
          margin: "auto",
        }}
      />
      <div className="buttonsFilter">
        <Button
          variant="outline-secondary"
          onClick={() => {
            handleCloseModal();
            dispatch(ChangetabFilterList([]));
            setFilterActiv(false);
            sessionStorage.removeItem("selectedFilterOptions");
            sessionStorage.removeItem("filterActiv");
          }}
        >
          Annuler
        </Button>
        <Button variant="dark" onClick={handleConfirm}>
          Appliquer
        </Button>
      </div>
    </Dropdown.Menu>
  );
}

export default FilterModal;
